import React, { useEffect } from "react";
import { useParams, useNavigate, useLocation, Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SUPPORTED_LANGS = ["es", "ro", "ar", "en", "fr", "zh", "pt", "it", "wo"];

const LanguageWrapper = () => {
  const { lang } = useParams();
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (lang && SUPPORTED_LANGS.includes(lang)) {
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang);
      }
      document.documentElement.lang = lang;

      // Manual SEO Update
      document.title = t("seo.title");
      
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute("content", t("seo.description"));
      }
      
      const ogTitle = document.querySelector('meta[property="og:title"]');
      if (ogTitle) ogTitle.setAttribute("content", t("seo.title"));
      
      const ogDescription = document.querySelector('meta[property="og:description"]');
      if (ogDescription) ogDescription.setAttribute("content", t("seo.description"));
    } else {
      // If lang is invalid or missing, redirect to detected or default 'es'
      const detectedLang = localStorage.getItem("i18n_lang") || "es";
      const targetLang = SUPPORTED_LANGS.includes(detectedLang) ? detectedLang : "es";
      
      // Keep the rest of the path
      const newPath = `/${targetLang}${location.pathname === "/" ? "" : location.pathname}`;
      navigate(newPath, { replace: true });
    }
  }, [lang, i18n, navigate, location.pathname, t]);

  if (lang && !SUPPORTED_LANGS.includes(lang)) return null;

  return <Outlet />;
};

export default LanguageWrapper;
